export default {"src":"/_next/static/media/introduce-arrow-down.a61db881.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};